import { onMounted, onUnmounted, ref } from "vue"

/**
 * Returns window dimensions
 */
export function useWindowSize () {
  const size = ref({
    left: 0,
    top: 0,
    right: window.innerWidth,
    bottom: window.innerHeight
  })

  const resize = () => {
    size.value.right = window.innerWidth
    size.value.bottom = window.innerHeight
  }

  onMounted(() => {
    window.addEventListener('resize', resize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', resize)
  })

  return size
}

